import React from "react";
import Backdrop from "@mui/material/Backdrop";

const AppBackdrop = ({ children, openModal, handleCloseModal }) => {
  return (
    <Backdrop
      sx={{
        overflow: "auto",
        display: "-webkit-box",
        color: "black",
        zIndex: (theme) => theme.zIndex.drawer + 1,
      }}
      open={openModal || false}
      onClick={handleCloseModal}
      style={{
        background: "#8b8b8b91",
        paddingTop: "2rem",
        paddingBottom: "2rem",
        paddingLeft: "0",
        paddingRight: "0",
        width: "100%",
        display: "flex",
        justifyContent: "center",
      }}
    >
      {children}
    </Backdrop>
  );
};

export default AppBackdrop;
